import { AgentOtpChannelEnum } from './../../../../service/dto';
import { AuthService } from './../../../../service/auth.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faKey, faLock, faUser, faUserAlt } from '@fortawesome/free-solid-svg-icons';
import { Callback } from '../../login.component';
import { AgentDto } from '../../../../service/dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-login-capture-password',
	templateUrl: './login-capture-password.component.html',
	styleUrl: './login-capture-password.component.scss',
	standalone: false
})
export class LoginCapturePasswordComponent implements OnInit {
	@Input() agent!: AgentDto;
	@Output("doUpdateState") doUpdateState = new EventEmitter<Callback>();
	form!: FormGroup;
	submitting: boolean = false;
	showPassword = false;
	message?: string;

	constructor(private authService: AuthService, private fb: FormBuilder) {

	}

	ngOnInit(): void {
		this.form = this.fb.group({
			username: [this.agent.username, [Validators.required, Validators.minLength(4)]],
			password: ['', [Validators.required, Validators.minLength(4)]]
		});
	}

	onSubmit() {
		const password = this.form.get('password')!.value;
		this.agent.password = password;
		this.submitting = true;
		this.authService.doCheckUsernameAndPassword(this.agent.username, password)
			.pipe(
				finalize(() => this.submitting = false)
			)
			.subscribe(result => {
				if (result.success == false) {
					this.message = result.message;
					return;
				}
				result.agent!.password = password;

				switch (result.agent!.status) {
					case 'PendingRegistration': return this.doUpdateState.emit({ mode: 'CaptureRegistrationOtp', agent: result.agent });
					case 'PendingApproval': return this.doUpdateState.emit({ mode: 'PendingApproval', agent: result.agent });
					case 'Rejected': return this.doUpdateState.emit({ mode: 'Rejected', agent: result.agent });
					case 'Approved': return this.doUpdateState.emit({ mode: 'CaptureOtp', agent: result.agent });
					case 'Blocked': return this.doUpdateState.emit({ mode: 'Blocked', agent: result.agent });
					case 'Suspended': return this.doUpdateState.emit({ mode: 'Suspended', agent: result.agent });
				}
			});
	}

	reset() {
		this.doUpdateState.emit({ mode: 'CaptureUsername', agent: this.agent });
	}
	isInvalid(field: string): boolean {
		return !!(this.form.get(field)?.invalid && this.form.get(field)?.touched);
	}
	showForgotPassword() {
		this.doUpdateState.emit({ mode: 'ForgotPasswordOtp', agent: this.agent });
	}

}
